export function prefillSearchInputFromUrl(input) {
  if (!(input instanceof HTMLInputElement)) {
    return;
  }
  const q = new URLSearchParams(window.location.search).get('q') || '';
  if (q !== '') {
    input.value = q;
  }
}
